/**
 * Cap product page gallery behavior — Dawn's gallery has no native
 * "images per variant" filtering (product-info.js's updateMedia only
 * reorders which image comes first / sets the hero, see the doc
 * comment in that file), so this fills that one gap without touching
 * Dawn core: every Cap photo except each color's hero "Left" shot is
 * unlinked from any variant (Shopify only allows ONE canonical image
 * per variant, so Details/Right can't also be variant-linked without
 * stealing the hero slot back off Left) — meaning Dawn shows all of
 * them, both colors, all the time, unless something filters them.
 * This hides whichever color ISN'T currently selected, on both mobile
 * and desktop alike, so only the selected color's own 3 angle photos
 * (hero + the two extras) ever show.
 *
 * Relies on each gallery image's alt text carrying "<Color> — <Angle>"
 * (set when the images were uploaded — see scripts/*.mjs history) as
 * the only reliable per-image signal available client-side without
 * extra product metafields.
 *
 * (2026-09-09: previously this also forced a fixed White-row/Black-row
 * comparison grid + a "Combo" hero image on desktop, showing both
 * colors permanently regardless of selection — that was a deliberate
 * design choice at the time, but the Combo image has since been
 * removed and the site now wants desktop to match mobile: swap to
 * just the selected color, like every other product. Simplified to
 * do that uniformly instead.)
 */
(function () {
  var mediaGallery = document.querySelector("media-gallery");
  if (!mediaGallery) return;
  if (!document.querySelector('input[data-option-name="Color"]')) return;

  function currentColor() {
    var checked = document.querySelector('input[data-option-name="Color"]:checked');
    return checked ? checked.value : null;
  }

  function applyFilter() {
    var color = currentColor();
    if (!color) return;

    // Matches both the main slide <li>s and the separate
    // thumbnail-strip <li>s — both carry their own <img alt> with the
    // same "<Color> — <Angle>" text, so filtering by tag name here
    // covers both lists without needing two separate queries.
    mediaGallery.querySelectorAll("li").forEach(function (li) {
      var img = li.querySelector("img");
      var alt = (img && img.alt) || "";
      var matchesColor = alt.indexOf(color) !== -1;
      li.classList.toggle("hidden", !matchesColor);
    });
  }

  // Dawn replaces the color radio <input> nodes wholesale on every
  // variant switch (variant-selects re-renders its contents via
  // HTMLUpdateUtility.viewTransition), so listeners bound directly to
  // the inputs at page-load time go stale after the first switch.
  // Delegating from document — which Dawn never replaces — instead of
  // the inputs themselves keeps this working across every switch.
  document.addEventListener("change", function (event) {
    if (event.target.matches('input[data-option-name="Color"]')) applyFilter();
  });

  // Dawn's own variant-change flow is async (it fetches the new
  // section HTML, then patches the DOM) — run again once that whole
  // flow (including updateMedia()'s own hero swap) has finished, so
  // this filter doesn't get overwritten by Dawn re-adding the other
  // color's images back into the gallery mid-swap. 'variant-change' is
  // published only after that flow completes (constants.js / pubsub.js,
  // both loaded globally in theme.liquid ahead of this deferred script).
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS === "object") {
    subscribe(PUB_SUB_EVENTS.variantChange, applyFilter);
  }

  // Gallery <li>s are present at parse time (server-rendered), but run
  // after DOMContentLoaded anyway in case Dawn's own gallery-init JS
  // reorders/rebuilds them first.
  document.addEventListener("DOMContentLoaded", applyFilter);
  if (document.readyState !== "loading") applyFilter();
})();
